'use client';

import { useTranslations } from 'next-intl';
import { SubheaderHelpCenter } from 'components/pcc-components';
import { HelpCenterClientProps } from './types';
import { useHelpCenterLinkClient } from 'hooks/use-help-center-link/use-help-center-link.client';

export const HelpCenterClient = ({
  helpCenterUrl,
  isMobile,
  isTargetBlank = false
}: HelpCenterClientProps) => {
  const t = useTranslations();
  const label = t('HELP_CTR_MNU_TITLE');
  const { helpCenterUrlWithCurrentPage } = useHelpCenterLinkClient({
    helpCenterUrl
  });

  return (
    <SubheaderHelpCenter
      displayMobileNavLink={isMobile}
      href={helpCenterUrlWithCurrentPage}
      label={label}
      isTargetBlank={isTargetBlank}
    />
  );
};
